import { render, staticRenderFns } from "./FooterEdition.vue?vue&type=template&id=57bc982c&scoped=true"
import script from "./FooterEdition.vue?vue&type=script&lang=js"
export * from "./FooterEdition.vue?vue&type=script&lang=js"
import style0 from "./FooterEdition.vue?vue&type=style&index=0&id=57bc982c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc982c",
  null
  
)

export default component.exports